export const setDetails = (state, payload) => {
    state.details = payload
}


// WEBPACK FOOTER //
// ./src/store/modules/events/mutations.js